export default {
  price_estimation: {
    // 🔹 Основное
    title: 'Immobilienbewertung',
    summary_title: 'Zusammenfassung',
    ai_prediction: 'KI-Bewertung',
    models_title: 'Estimator24 Modelle',
    not_ready: 'Bewertung noch nicht durchgeführt',

    // 🔹 Ценовые показатели
    price_label: 'Objektpreis',
    market_range: 'Marktbereich',
    avg_label: 'Durchschnittspreis',
    median_label: 'Medianpreis',

    // 🔹 Состояние относительно рынка
    within_range: 'Innerhalb des Marktbereichs',
    above_range: 'Überbewertet um +{percent}%',
    below_range: 'Unterbewertet um −{percent}%'
  }
}
